import React from 'react'
import { isEmpty } from 'util/arrays'
import { Button } from 'util/ui'
import { getTimestampDisplayString } from 'util/date'
import { getFormattedPrice } from 'util/numbers'
import EmptyMessage from '../shared/EmptyMessage'
import Section from '../shared/Section'
import List from '../shared/List'
import ContentCard from '../shared/ContentCard'

const ShopifyView = ({
  data,
  seeAllOrdersUrl,
  seeCustomerUrl,
  seeOrderUrls,
}) => {
  const { shop, customer } = data
  return (
    shop && (
      <React.Fragment>
        <Section label="Customer info">
          {!customer && (
            <EmptyMessage>There is no customer information</EmptyMessage>
          )}
          {customer && (
            <ContentCard title={`${customer.first_name} ${customer.last_name}`}>
              <List.Container>
                {customer.id && (
                  <List.Item label="Customer ID">
                    <a
                      href={seeCustomerUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {customer.id}
                    </a>
                  </List.Item>
                )}
                {customer.created_at && (
                  <List.Item label="Signed up">
                    {getTimestampDisplayString(customer.created_at)}
                  </List.Item>
                )}
                {customer.total_spent && (
                  <List.Item label="Lifetime orders">
                    {getFormattedPrice(customer.total_spent, shop.currency)}
                  </List.Item>
                )}
                {customer.orders_count && (
                  <List.Item label="Total orders">
                    {customer.orders_count}
                  </List.Item>
                )}
                {customer.default_address && (
                  <List.Item label="Primary address">
                    <List.Address
                      addressFirst={customer.default_address.address1}
                      addressSecond={customer.default_address.address2}
                      city={customer.default_address.city}
                      country={customer.default_address.country}
                      province={customer.default_address.province}
                      zip={customer.default_address.zip}
                    />
                  </List.Item>
                )}
              </List.Container>
            </ContentCard>
          )}
        </Section>
        <Section label="Recent orders">
          {(!customer || !customer.orders || isEmpty(customer.orders)) && (
            <EmptyMessage>No order placed yet</EmptyMessage>
          )}
          {customer &&
            customer.orders &&
            customer.orders.map(order => (
              <ContentCard
                key={order.id}
                title={`Order: #${order.order_number}`}
              >
                <List.Container>
                  {order.id && (
                    <List.Item label="Order">
                      {seeOrderUrls ? (
                        <a
                          href={seeOrderUrls[order.id]}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          #{order.order_number}
                        </a>
                      ) : (
                        order.id
                      )}
                    </List.Item>
                  )}
                  {order.created_at && (
                    <List.Item label="Date">
                      {getTimestampDisplayString(order.created_at)}
                    </List.Item>
                  )}
                  {order.fulfillment_status && (
                    <List.Item label="Fulfillment">
                      {order.fulfillment_status}
                    </List.Item>
                  )}
                  {order.total_price && (
                    <List.Item label="Total price">
                      {getFormattedPrice(order.total_price, shop.currency)}
                    </List.Item>
                  )}
                  {order.shipping_address && (
                    <List.Item label="Shipping address">
                      <List.Address
                        addressFirst={order.shipping_address.address1}
                        addressSecond={order.shipping_address.address2}
                        city={order.shipping_address.city}
                        country={order.shipping_address.country}
                        province={order.shipping_address.province}
                        zip={order.shipping_address.zip}
                      />
                    </List.Item>
                  )}
                </List.Container>
              </ContentCard>
            ))}
        </Section>
        {customer && (
          <Section>
            <Button
              as="a"
              href={seeAllOrdersUrl}
              target="_blank"
              size="small"
              primary
            >
              View all recent orders in shopify
            </Button>
          </Section>
        )}
      </React.Fragment>
    )
  )
}

export default ShopifyView
